import jwt from 'jsonwebtoken';
import axios from 'axios';

const RefreshToken = (glob_pay_admin_auth, logout, login) => {
  const refresh = async () => {
    let token = glob_pay_admin_auth.access_token;
    console.log('token function', glob_pay_admin_auth);
    // let decodedToken = jwt.decode(token, { complete: true });
    // let decodedTokenTime = decodedToken.payload.exp * 1000;

    let user = glob_pay_admin_auth.user;
    let decodedTokenTime = user.exp * 1000;
    let dateNow = new Date();
    let NumaricDate = dateNow.getTime();

    try {
      if (user && decodedTokenTime > NumaricDate) {
        console.log('my access token:', token);

        return token;
      } else {
        let data = {
          grant_type: 'refresh_token',
          client_id: process.env.REACT_APP_CLIENT_ID,
          client_secret: process.env.REACT_APP_CLIENT_SECRECT,
          refresh_token: glob_pay_admin_auth.refresh_token,
        };
        let res = await axios({
          url: '/api/v1/public/auth/refresh-token',
          method: 'POST',
          data: data,
          headers: {
            'Content-Type': 'application/json',
          },
        });
        login(res.data.data);
        console.log('refresh token', res.data.data.access_token);
        return res.data.data.access_token;
      }
    } catch (error) {
      logout();
    }
  };
  return refresh();
};

export default RefreshToken;
